module.exports = __webpack_public_path__ + "img/ajax-loader.2c5d815.gif";